<template>
    <b-modal
        ref="previewModal"
        centered
        title="Preview Your Form"
        size="lg"
    >
        <div v-if="formData">
            <FormBuilderGui :form="formData" :key="formData._uniqueId" :rowData="rowData" :gridId="gridId"/>
        </div>

        <div slot="modal-footer">
            <button type="button" class="btn btn-default" @click="closeModal">Close</button>
        </div>
    </b-modal>
</template>

<script>
    import FormBuilderGui from '@/components/DataGrid/FormBuilder/gui/FormBuilderGui';

    export default {
        name: "PreviewComponent",
        components: {FormBuilderGui},
        props: ['form', 'gridId', 'rowData'],
        data: () => ({
            previewModal: null,
            formData: null
        }),
        methods: {
            openModal(formData) {
                // set data
                this.formData = _.cloneDeep(formData);
                this.formData._uniqueId = Math.random();

                // open
                if (this.$refs.previewModal) this.$refs.previewModal.show()
            },
            closeModal() {
                if (this.$refs.previewModal) this.$refs.previewModal.hide()
            }
        }
    }
</script>

<style scoped>

</style>
